import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import slide1 from '../../assets/slide3_3_mini.png';
import slide2 from '../../assets/slide_2_1_mini.png';
import slide3 from '../../assets/slide_1_1_good.png';

const Carousel = () => {

    const slideList = [
        {
            src: slide1,
            width: '75%',
            height: '100%',
            backgroundColor: '#E1F5F9',
        },
        {
            src: slide2,
            width: '75%',
            height: '100%',
            backgroundColor: 'white',
        },
        {
            src: slide3,
            width: '75%',
            height: '100%',
            backgroundColor: '#F7E6C5',
            text: <label>기업의  #발전  #에너지  #연료  #엔진</label>,
            textColor: 'black',
            textBackgroundColor: 'white',
        },
    ]

    return (
        <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            loop={true}
            autoplay={{ delay: 3000 }}
            pagination={{ clickable: true }}
            navigation
            style={{ width: '75%', height: '100%' }}
        >
            {slideList?.map((item, idx) => (
                <SwiperSlide
                    key={idx}
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '300px', // 필 요 시 vh 단위로 조절 가능
                        backgroundColor: item?.backgroundColor,
                    }}
                >
                    {item?.src && (
                        <img
                            src={item?.src}
                            alt={`slide${idx + 1}`}
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain',
                            }}
                        />
                    )}
                    {item?.text && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '62%',
                                backgroundColor: item.textBackgroundColor,
                                color: item.textColor || 'black',
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                padding: '20x 10px', // 내부 여백 추가
                                borderRadius: '4px', // ← 라운드 효과
                            }}
                        >
                            {item.text}
                        </div>

                    )}
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default Carousel;
